import {AGMAgentGlobalBetListPage, FullAgentsListPage} from "../pages";

const routes = {
  root: '/',
  dashboard: {
    root: '/',
    settings: '/dashboard/settings',
  },

  admin: {
    root: '/admin',
    finance_report: {
      root: '/admin/finance_report',
      finance_report_details_root: '/admin/finance_report/details',
      finance_report_details: '/admin/finance_report/details/:reportId',
      finance_report_details_mobile_view: '/admin/finance_report/details/:reportId/full_details/:affiliateId',
      finance_report_consolidate_details: '/admin/finance_report/consolidate_details/:reportId',
      finance_report_payment_details: '/admin/finance_report/details/:reportId/payment_details',
      //'/admin/finance_report/details/19/payment_details/123123/null/null',
      //'/admin/finance_report/details/19/payment_details/1283126',
      //'/admin/finance_report/details/19/payment_details?affId=1232132&curr=null&brand=null',
    },
    creatives: {
      root: '/admin/creatives',
      creative: '/admin/creatives/:creativeId',
      edit: '/admin/creatives/:creativeId/edit',
      details: {
        root: '/admin/creatives/details',
        main: '/admin/creatives/details/:creativeId',
      },
    },
    creatives_v2: {
      root: '/admin/creatives-v2',
      creative: '/admin/creatives-v2/:creativeId',
      edit: '/admin/creatives-v2/:creativeId/edit',
      create: '/admin/creatives-v2/create',
      details: {
        root: '/admin/creatives-v2/details',
        main: '/admin/creatives-v2/details/:creativeId',
      },
    },
    trackers: {
      root: '/admin/trackers',
      creatives: {
        root: '/admin/trackers/creatives/',
        id: '/admin/trackers/creatives/:trackersId',
      },
      condition: {
        root: '/admin/trackers/condition/',
        id: '/admin/trackers/condition/:trackersId',
      }
    },
    settings: {
      root: '/admin/settings_profile',
      main: '/admin/settings_profile/main',
      password: {
        root: '/admin/settings_profile/password',
      },
      two_fa: {
        root: '/admin/settings_profile/two_fa',
      },
    },
    downloadReport: {
      root: '/admin/download_report',
    },
    partners: {
      root: '/admin/partners',
      details: {
        root: '/admin/partners/details',
        main: '/admin/partners/details/:affId',
      },
      profile: {
        root: '/admin/partners/profile',
        main: '/admin/partners/profile/:affId',
        paymentHistory: {
          root: '/admin/partners/profile/:affId',
          details: '/admin/partners/profile/:affId/payment_history/:id',
          detailsRoot: '/admin/partners/profile/:affId',
        }
      },
      deals: {
        root: '/admin/partners/deals',
        main: '/admin/partners/deals/:affId',
        details: {
          root: '/admin/partners/deals/details',
          main: '/admin/partners/deals/details/:dealId',
        },
        general: {
          root: '/admin/partners/deals/:affId/general',
        },
        trackers: {
          root: '/admin/partners/deals/:affId/trackers',
          conditions: '/admin/partners/deals/:affId/trackers/:trackerId/conditions',
          details: '/admin/partners/deals/:affId/trackers/:trackerId/details',
          creatives: {
            root: '/admin/partners/deals/:affId/trackers/:trackerId/creatives',
            link: {
              root: '/admin/partners/deals/:affId/trackers/:trackerId/creatives/:creativeId'
            }
          },
          additional_settings: '/admin/partners/deals/:affId/trackers/:trackerId/additional_settings',
        },
        subaffiliate: {
          root: '/admin/partners/deals/:affId/condition',
        },
        additional_settings: {
          root: '/admin/partners/deals/:affId/additional_settings',
        }
      },
      new_partner: {
        root: '/admin/partners/new_partner',
      },
      account: {
        root: '/admin/partner/profile',
        main: '/admin/partner/profile/:affId',
        overview: '/admin/partner/profile/:affId/overview',
        communication: '/admin/partner/profile/:affId/communication',
        commission: '/admin/partner/profile/:affId/commission',
        payment_details: '/admin/partner/profile/:affId/payment-details',
        payment_history: '/admin/partner/profile/:affId/payment-history',
        payment_history_details: '/admin/partner/profile/:affId/payment-history/:id',
        other_info: '/admin/partner/profile/:affId/other-info',
        trackers: {
          root: '/admin/partner/profile/:affId/trackers',
          conditions: '/admin/partner/profile/:affId/trackers/:trackerId/conditions',
          details: '/admin/partner/profile/:affId/trackers/:trackerId/details',
          creatives: {
            root: '/admin/partner/profile/:affId/trackers/:trackerId/creatives',
            link: {
              root: '/admin/partner/profile/:affId/trackers/:trackerId/creatives/:creativeId'
            }
          },
          additional_settings: '/admin/partner/profile/:affId/trackers/:trackerId/additional-settings',
        },
      },
      send_email: {
        root: '/admin/partner/send_email',
      }
    },
    invitation_links: {
      root: '/admin/invitation_links',
    },
    creativeReports: {
      root: '/admin/report/creative',
    },
    summary_report: {
      root: '/admin/summary_report',
    },
    summary_report_v2: {
      root: '/admin/player-and-commission-report',
    },
    player_commission_report: {
      root: '/admin/statistics-report',
    },
    full_statistics_report: {
      root: '/admin/full-report',
    },
    summary_statistics_report_v3: {
      root: '/admin/summary-report-v3',
    },
    subaff_report: {
      root: '/admin/subaffiliate_reports'
    },
    agent_statistics_report: {
      root: '/admin/agent-statistics-report',
    },
    roles_and_permissions: {
      root: '/admin/roles_and_permissions',
    },
    webhooks_report: {
      root: '/admin/webhooks_report'
    },
    deals: {
      root: '/admin/deals',
      create: '/admin/deals/create',
      edit: '/admin/deals/edit/:id',
      editRoot: '/admin/deals/edit',
      detailsRoot: '/admin/deals/details',
      details: '/admin/deals/details/:id',
    },
    employees: {
      root: '/admin/employees',
      details: '/admin/employees/:id'
    },
    quints_api: {
      root: '/admin/api'
    },
    old_creative_report: {
      root: '/admin/creative_reports_old',
      editRoot: '/admin/deals/edit',
      detailsRoot: '/admin/deals/details',
      details: '/admin/deals/details/:id',
    },
    sub_aff_deals: {
      root: '/admin/sub-affiliate-deals',
      create: '/admin/sub-affiliate-deals/create',
      edit: '/admin/sub-affiliate-deals/edit/:id',
      editRoot: '/admin/sub-affiliate-deals/edit',
      detailsRoot: '/admin/sub-affiliate-deals/details',
      details: '/admin/sub-affiliate-deals/details/:id',
    },
	  sub_aff_deals_v2: {
      root: '/admin/sub-affiliate-deals-v2',
      create: '/admin/sub-affiliate-deals-v2/create',
      edit: '/admin/sub-affiliate-deals-v2/edit/:id',
      editRoot: '/admin/sub-affiliate-deals-v2/edit',
      detailsRoot: '/admin/sub-affiliate-deals-v2/details',
      details: '/admin/sub-affiliate-deals-v2/details/:id',
    },
    players_list: {
      root:  '/admin/players_list',
      profile: '/admin/players_list/view_player/:playerId'
    },
    system: {
      root: '/admin/settings',
      email: '/admin/settings/email-templates',
    },
    offers: {
      root: '/admin/offers',
      create: '/admin/offers/create',
      edit: '/admin/offers/edit/:offerId',
    },
    brands: {
      root: '/admin/brands',
      create: '/admin/brands/create',
      edit: '/admin/brands/edit/:brandsId',
      details: '/admin/brands/:brandsId'
    },
    external_brands: {
      root: '/admin/external-brands',
      create: '/admin/external-brands/create',
      edit: '/admin/external-brands/edit/:brandsId',
      details: '/admin/external-brands/:brandsId'
    },
    billing: {
      root: '/admin/billing',
      create_update: '/admin/billing/package',
    },
    agent: {
      root: '/admin/user-list',
      create: '/admin/user-list/create',
      details: '/admin/user-list/details/:id',
      agentManagement: '/admin/agent-management',
      createPlayer: '/admin/user-list/create-player',
      list: {
        root: '/admin/user-list/',
        profile: '/admin/user-list/agent/:id',
      },
      players: {
        details: '/admin/user-list/players/details/:id',
        profile: '/admin/user-list/player/:id',
      },
      transactionsHistory: {
        root: '/admin/transactions-history',
        transfersHistory: '/admin/transfers-history',
        allTransfersHistory: '/admin/all-transfers-history',
      },
      fullAgentsList: {
        root: '/admin/full-user-list',
        details: '/admin/full-user-list/details/:id',
        profile: '/admin/full-user-list/agent/:id',
      },
      fullPlayers: {
        details: '/admin/full-user-list/players/details/:id',
        playerAccount: {
          root: '/admin/full-user-list/player/profile',
          main: '/admin/full-user-list/player/profile/:id',
          overview: '/admin/full-user-list/player/profile/:id/overview',
          sportBetList: '/admin/full-user-list/player/profile/:id/sport-bet-list',
          casinoBetList: '/admin/full-user-list/player/profile/:id/casino-bet-list',
        }
      },
      playerAccount: {
        root: '/admin/user-list/player/profile',
        main: '/admin/user-list/player/profile/:id',
        overview: '/admin/user-list/player/profile/:id/overview',
        sportBetList: '/admin/user-list/player/profile/:id/sport-bet-list',
        casinoBetList: '/admin/user-list/player/profile/:id/casino-bet-list',
      },
      globalBetList: {
        root: '/admin/global-bet-list',
      },
    },
	  flatFee: {
			root: '/admin/flat-fee',
			details: '/admin/flat-fee/details/:flatFeeId',
	  },
    cashier: {
      root: '/admin/cashier-list',
      create: '/admin/cashier-list/create',
      details: '/admin/cashier-list/details/:id',
      list: {
        root: '/admin/cashier-list',
        profile: '/admin/cashier-list/cashier/:id',
      },
      transactionsHistory: {
        root: '/admin/cashier/transactions-history',
        transfersHistory: '/admin/cashier/all-transfers-history',
        cashierTransfer: '/admin/cashier/transfers-history',
      },
    }
  },

  affiliate: {
    root: '/affiliate',
    settings: {
      root: '/affiliate/settings_profile',
      main: '/affiliate/settings_profile/main',
      email: '/affiliate/settings_profile/email',
      password: '/affiliate/settings_profile/password',
      payment: '/affiliate/settings_profile/payment',
      twofa: '/affiliate/settings_profile/twofa',
    },
    trackers: {
      root: '/affiliate/trackers',
      details: {
        root: '/affiliate/trackers/details',
        id: '/affiliate/trackers/details/:trackerId',
        creatives: {
          root: '/affiliate/trackers/details/:trackerId/creatives',
          link: {
            root: '/affiliate/trackers/details/:trackerId/creatives/:creativeId'
          }
        }
      }
    },
    api: {
      root: '/affiliate/api',
    },
    summaryReport: {
      root: '/affiliate/summary_report',
    },
    summary_report_v2: {
      root: '/affiliate/player-and-commission-report',
    },
    statistics_report: {
      root: '/affiliate/statistics-report',
    },
    s2s: {
      root: '/affiliate/webhook',
      details: '/affiliate/webhook/:webhookId',
    },
    creativeReport: {
      root: '/affiliate/creative_report',
    },
    subAffiliateReport: {
      root: '/affiliate/subaffiliate_report',
    },
    downloadReport: {
      root: '/affiliate/download_report',
    },
    faq: {
      root: '/affiliate/faq',
    },
    reference: {
      root: '/affiliate/reference'
    },
    newCreativeReport: {
      root: '/affiliate/new_creative_report',
    },
    offers_list: {
      root: '/affiliate/offers_list',
      details: '/affiliate/offers_list/details/:offerId',
    },
    paymentHistory: {
      root: '/affiliate/payment_history',
      details: '/affiliate/payment_history/details/:id',
      detailsRoot: '/affiliate/payment_history/details',
    }
  },

  agent: {
    root: '/agent',
    agentsList: {
      root: '/agent/user-list',
      createAgent: '/agent/user-list/create-agent',
      createPlayer: '/agent/user-list/create-player',
      details: '/agent/user-list/details/:id',
      agentProfile: '/agent/user-list/agent/:id',
      players: {
        details: '/agent/user-list/players/details/:id',
      },
      playerAccount: {
        root: '/agent/user-list/player/profile',
        main: '/agent/user-list/player/profile/:id',
        overview: '/agent/user-list/player/profile/:id/overview',
        sportBetList: '/agent/user-list/player/profile/:id/sport-bet-list',
        casinoBetList: '/agent/user-list/player/profile/:id/casino-bet-list',
      }
    },

    settings: {
      root: '/agent/settings_profile',
      main: '/agent/settings_profile/main',
      email: '/agent/settings_profile/email',
      password: '/agent/settings_profile/password',
      payment: '/agent/settings_profile/payment',
      twofa: '/agent/settings_profile/twofa',
    },
    transactionsHistory: {
      root: '/agent/transactions-history',
      transfersHistory: '/agent/transfers-history',
    },
    agentStatisticsReport: {
      root: '/agent/agent-statistics-report',
    },
	  downloadReport: {
		  root: '/agent/download_report',
	  },
    globalBetList: {
		  root: '/agent/global-bet-list',
	  },
  },

  cashier: {
    transactionsHistory: {
      root: '/cashier/transactions-history',
      transfersHistory: '/cashier/transfers-history',
    },
    root: '/',
    dashboard: {
      root: '/',
    },
    withdrawalList: {
      root: '/cashier/withdrawal-list',
      /*createAgent: '/agent/user-list/create-agent',
      createPlayer: '/agent/user-list/create-player',
      details: '/agent/user-list/details/:id',
      agentProfile: '/agent/user-list/agent/:id',
      players: {
        details: '/agent/user-list/players/details/:id',
      },
      playerAccount: {
        root: '/agent/user-list/player/profile',
        main: '/agent/user-list/player/profile/:id',
        overview: '/agent/user-list/player/profile/:id/overview',
        sportBetList: '/agent/user-list/player/profile/:id/sport-bet-list',
        casinoBetList: '/agent/user-list/player/profile/:id/casino-bet-list',
      }*/
    },
    transfersHistory: {
      root: '/cashier/transfers-history',
    },
    settings: {
      root: '/cashier/profile',
      main: '/cashier/profile/main',
      email: '/cashier/profile/email',
      password: '/cashier/profile/password',
      payment: '/cashier/profile/payment',
      twofa: '/cashier/profile/twofa',
    },
  },

  common: {
    auth: '/auth',
    registration: '/registration',
    dashboard: '/dashboard',
    confirmation: '/registration/confirmation/:confirmationId',
    terms: '/terms',
    privacyPolicy: '/privacy-policy',
    faq: '/faq',
    affiliate_ref: '/affiliate_ref/:token',
    passwordRecovery: '/password/recovery',
    confirmRecoveryRoot: '/password/confirm',
    confirmRecovery: '/password/confirm/:token',
    changePassword: '/password/change/:token',
    changePassRoot: '/password/change',
    inviteAdmin: '/invite/password/:token',
    invitePartner: '/password/setup/:token',
    twofa_email: '/email',
    twofa_google: '/google',
    maintenance: 'maintenance'
  }
};

export default routes;
